// 9fbef606107a605d69c0edbcd8029e5d
import { WRITE_REVIEW_ACTION_PATTERN } from '../../../../constants/reducer.constants';

const WRITE_REVIEW_CONSTANTS = {
  SET_WRITE_REVIEW_MODAL_MOUNTED_STATE: `${WRITE_REVIEW_ACTION_PATTERN}SET_WRITE_REVIEW_MODAL_MOUNTED_STATE`,
  SET_ADD_PHOTO_MODAL_MOUNTED_STATE: `${WRITE_REVIEW_ACTION_PATTERN}SET_ADD_PHOTO_MODAL_MOUNTED_STATE`,
  SET_ADD_VIDEO_MODAL_MOUNTED_STATE: `${WRITE_REVIEW_ACTION_PATTERN}SET_ADD_VIDEO_MODAL_MOUNTED_STATE`,
  SET_SUBMISSION_FEEDBACK_MODAL_MOUNTED_STATE: `${WRITE_REVIEW_ACTION_PATTERN}SET_SUBMISSION_FEEDBACK_MODAL_MOUNTED_STATE`,
  SET_WRITE_REVIEW_PRODUCT_DATA: `${WRITE_REVIEW_ACTION_PATTERN}SET_WRITE_REVIEW_PRODUCT_DATA`,
  SET_WRITE_REVIEW_ADD_PHOTO_DATA: `${WRITE_REVIEW_ACTION_PATTERN}SET_WRITE_REVIEW_ADD_PHOTO_DATA`,
  SET_WRITE_REVIEW_ADD_VIDEO_DATA: `${WRITE_REVIEW_ACTION_PATTERN}SET_WRITE_REVIEW_ADD_VIDEO_DATA`,
  SET_WRITE_REVIEW_ADD_PHOTO_MODAL_INITIAL_DATA: `${WRITE_REVIEW_ACTION_PATTERN}SET_WRITE_REVIEW_ADD_PHOTO_MODAL_INITIAL_DATA`,
  SET_WRITE_REVIEW_ADD_VIDEO_MODAL_INITIAL_DATA: `${WRITE_REVIEW_ACTION_PATTERN}SET_WRITE_REVIEW_ADD_VIDEO_MODAL_INITIAL_DATA`,
  REMOVE_RATE_AND_REVIEW_ID: `${WRITE_REVIEW_ACTION_PATTERN}REMOVE_RATE_AND_REVIEW_ID`,
};

export const PIXLEE_RATING_SUB_DIMENSIONS = {
  recommendproduct: {
    true: 1,
    false: 2,
  },
  quality: {
    1: 3,
    2: 4,
    3: 5,
    4: 6,
    5: 7,
  },
  styling: {
    1: 8,
    2: 9,
    3: 10,
    4: 11,
    5: 12,
  },
  durability: {
    1: 13,
    2: 14,
    3: 15,
    4: 16,
    5: 17,
  },
  value: {
    1: 18,
    2: 19,
    3: 20,
    4: 21,
    5: 22,
  },
  comfort: {
    1: 23,
    2: 24,
    3: 25,
    4: 26,
    5: 27,
  },
  fit: {
    1: 28,
    2: 29,
    3: 30,
    4: 31,
    5: 32,
  },
};

export const PIXLEE_SHOPPER_PROFILES = {
  location: {
    id: 1,
  },
  recommendTCPRating: {
    0: 2,
    1: 3,
    2: 4,
    3: 5,
    4: 6,
    5: 7,
    6: 8,
    7: 9,
    8: 10,
    9: 11,
    10: 12,
  },

  recommendTCPComment: {
    id: 13,
  },
};

export default WRITE_REVIEW_CONSTANTS;
